import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { add, load } from '../../../reducers/paymentTypes/paymentTypes.actions';
import { paymentTypes, loading } from '../../../reducers/paymentTypes/paymentTypes.reducer';
import { Spinner } from '../../Spinner/Spinner';
import './AdminPaymentTypes.css';
import ConnectedPaymentTypeForm from './PaymentTypeForm/PaymentTypeForm';

export class AdminPaymentTypes extends React.Component {
  componentDidMount() {
    this.props.load();
  }

  render() {
    return (
      <span>
        <Spinner isLoading={this.props.arePaymentTypesLoading} />
        <Row style={{ 'margin-bottom': '15px' }}><Col><Button onClick={this.props.addPaymentType} bsStyle="primary">Add New PaymentType</Button></Col></Row>
        {this.props.paymentTypes.map(paymentType => (
          <Row key={paymentType.id}>
            <Col>
              <ConnectedPaymentTypeForm paymentType={paymentType} />
            </Col>
          </Row>
          ))}
        <Row><Col><Button onClick={this.props.addPaymentType} bsStyle="primary">Add New PaymentType</Button></Col></Row>
      </span>
    );
  }
}

AdminPaymentTypes.propTypes = {
  load: PropTypes.func.isRequired,
  addPaymentType: PropTypes.func.isRequired,
  arePaymentTypesLoading: PropTypes.bool.isRequired,
  paymentTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export const mapStateToProps = state => ({
  arePaymentTypesLoading: loading(state),
  paymentTypes: paymentTypes(state),
});

export const mapDispatchToProps = dispatch => ({
  load: () => dispatch(load()),
  addPaymentType: () => dispatch(add()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminPaymentTypes);



// WEBPACK FOOTER //
// ./src/components/Admin/PaymentTypes/AdminPaymentTypes.jsx